export { Command as default } from "./command";
